// extracted by mini-css-extract-plugin
export default {"zoomModal":"p4-z"};